import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Fade from "@mui/material/Fade";
import { Box, Typography, styled } from "@mui/material";
import Button from "../../components/Button";
import CustomTextField from "../../components/Textfield";
import { getSx } from "../../components/Modal/style";
import { useDispatch } from "react-redux";
import { showToast } from "../../store/slices/common";
import { validateEmail } from "../../utils";
import { createUser } from "../../http/auth";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Fade ref={ref} {...props} />;
});

const CustomDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    width: "400px",
    padding: "30px",
    borderRadius: "20px",
  },
  "& .MuiPaper-root": { maxWidth: "400px" },
  "& .MuiDialogActions-root": {},
}));

export default function CreateUser({ open, setOpen }) {
  const [formData, setFormData] = React.useState({});
  const classes = getSx(true);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (!open) {
      setFormData({});
    }
  }, [open]);

  const onChangeHandler = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const onClickHandler = async () => {
    try {
      const res = await createUser(formData);
      if (res.status === 200) {
        dispatch(
          showToast({ msg: "User created successfully", color: "success" })
        );
      }
    } catch (error) {
      dispatch(showToast({ msg: "Something went wrong", color: "error" }));
    }
    setOpen(false);
    setFormData({});
  };

  const disabled =
    !validateEmail(formData.email) ||
    !formData.name ||
    !formData.email ||
    !formData.password;

  return (
    <CustomDialog
      open={open}
      keepMounted
      onClose={() => setOpen(false)}
      TransitionComponent={Transition}
      sx={{ "& .MuiPaper-root": { maxWidth: "400px" } }}
    >
      <DialogContent sx={{ padding: "8px 20px" }}>
        <Box sx={{ ...classes.subTitleContainer, gap: "1rem" }}>
          <Box>
            <Typography
              sx={{
                fontSize: "18px",
                minWidth: "300px",
                maxWidth: "400px",
              }}
            >
              Name<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomTextField
              sx={{
                width: "50%",
                minWidth: "300px",
                maxWidth: "400px",
              }}
              name="name"
              placeholder="Enter Name"
              value={formData.name || ''}
              onChange={onChangeHandler}
              type="text"
            />
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: "18px",
                minWidth: "300px",
                maxWidth: "400px",
              }}
            >
              Email<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomTextField
              sx={{
                width: "50%",
                minWidth: "300px",
                maxWidth: "400px",
              }}
              name="email"
              placeholder="Enter Email"
              value={formData.email || ''}
              onChange={onChangeHandler}
              type="text"
            />
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: "18px",
                minWidth: "300px",
                maxWidth: "400px",
              }}
            >
              Password<span style={{ color: "red" }}>*</span>
            </Typography>
            <CustomTextField
              sx={{
                width: "50%",
                minWidth: "300px",
                maxWidth: "400px",
              }}
              name="password"
              placeholder="Enter Password"
              value={formData.password || ''}
              onChange={onChangeHandler}
              type="password"
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions
        disableSpacing={false}
        sx={{ ...classes.buttonWrapper, justifyContent: "center" }}
      >
        <Button
          style={classes.button}
          label="Create User"
          onClick={onClickHandler}
          disabled={disabled}
        />
      </DialogActions>
    </CustomDialog>
  );
}
